import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function QRPHKnowledge({ navigation, primaryDetails, setPrimaryDetails }) {
  const [details, setDetails] = useState({
    qrph_maya_ewallet_payments: "",
    qrph_maya_qr_payments: "",
    qrph_gcash_no_logo: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {
      qrph_maya_ewallet_payments: !details.qrph_maya_ewallet_payments,
      qrph_maya_qr_payments: !details.qrph_maya_qr_payments,
      qrph_gcash_no_logo: !details.qrph_gcash_no_logo,
    };
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    // Combine all 3 answers into a single comma-separated string
    const combinedAnswer = `${details.qrph_maya_ewallet_payments},${details.qrph_maya_qr_payments},${details.qrph_gcash_no_logo}`;
    setPrimaryDetails((prev) => ({
      ...prev,
      qrph_knowledge: combinedAnswer,
    }));
    if (navigation && navigation.go) navigation.go('interested-maya-solution');
  };

  const handleBack = () => {
   navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">QRPH Knowledge</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  <Form.Group className={`mb-4 ${errors.qrph_maya_ewallet_payments ? 'form-group-error' : ''}`}>
                    <Form.Label className="form-label">
                      Tumatanggap ba kayo ng payments sa Maya galing sa ibang e-wallets? <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {["Yes", "No"].map((opt, index) => (
                        <div
                          key={`qrph-maya-ewallet-${index}-${opt}`}
                          className={`form-radio-item${details.qrph_maya_ewallet_payments === opt ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="qrph_maya_ewallet_payments"
                              value={opt}
                              label={opt}
                              checked={details.qrph_maya_ewallet_payments === opt}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.qrph_maya_ewallet_payments && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                  <Form.Group className={`mb-4 ${errors.qrph_maya_qr_payments ? 'form-group-error' : ''}`}>
                    <Form.Label className="form-label">
                      Tumatanggap ba kayo ng Maya QR payments?<span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {["Yes", "No"].map((opt, index) => (
                        <div
                          key={`qrph-maya-qr-${index}-${opt}`}
                          className={`form-radio-item${details.qrph_maya_qr_payments === opt ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="qrph_maya_qr_payments"
                              value={opt}
                              label={opt}
                              checked={details.qrph_maya_qr_payments === opt}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.qrph_maya_qr_payments && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>
                  
                  <Form.Group className={`mb-4 ${errors.qrph_gcash_no_logo ? 'form-group-error' : ''}`}>
                    <Form.Label className="form-label">
                      GCash QR Displayed with No QRPH logo? <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {["Yes", "No"].map((opt, index) => (
                        <div
                          key={`qrph-gcash-${index}-${opt}`}
                          className={`form-radio-item${details.qrph_gcash_no_logo === opt ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="qrph_gcash_no_logo"
                              value={opt}
                              label={opt}
                              checked={details.qrph_gcash_no_logo === opt}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.qrph_gcash_no_logo && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>


                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back 
                    </AppButton>
                    <AppButton onClick={handleSubmit} variant="next" className="form-btn variant-primary">
                     Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default QRPHKnowledge;
